import { getMicroAppVars, getFrameworkVar, actions, store, history, isAppCanBeLaunched } from '@sparky/framework'
import { MICRO_APP_NAME, APP_ID_PRISMA_ACCESS, VIEW_PAGE_PATH_MAPPING, PA_DEFAULT_ROUTE, MSP_URL } from '../constants/GlobalConstants'
import type { Tsg, Instance, AsyncCache } from '@sparky/framework'
import type { CommonModuleState } from '../types'
import { FF_USE_NEW_LEFT_NAV } from './FeatureFlags'

export {
  getFrameworkVar,
  getFrameworkServiceUrl,
  isAppCanBeLaunched,
  events,
  getAuthState,
  getTsgAccess,
  getState as getGlobalState,
  dispatch as globalDispatch,
  hasMicroApp,
  isOidcClient,
  getTsgIdFromUrl,
  cleanupTsgIdFromUrl,
  history,
  indexAppManifests,
} from '@sparky/framework'

export const getVarValue = <T = any>(name: string, fallback: T | null = null): T | null | undefined => getMicroAppVars(MICRO_APP_NAME)?.[name] ?? fallback

export const getCommonModuleState = () => store?.stateRef?.current?.commonModule as CommonModuleState
export const setCommonModuleValues = (values: Partial<CommonModuleState>): void => {
  const commonModule = store?.stateRef?.current?.commonModule
  actions?.setValues({
    commonModule: {
      ...commonModule,
      ...values,
    },
  })
}

export const setCurrentViewing = (currentView: string | undefined) => {
  if (!getFrameworkVar(FF_USE_NEW_LEFT_NAV)) {
    setCommonModuleValues({
      path: currentView,
      visible: true,
    })
  }
  else if (currentView) {
    let mapped = VIEW_PAGE_PATH_MAPPING[currentView]
    if (mapped) {
      if (history.location.pathname.startsWith(MSP_URL)) {
        mapped = `${MSP_URL}${mapped}`
      }
      history.push(mapped)
    }
  }
}

export const setIsGlobalModuleOpen = (isGlobalModuleOpen: boolean) => {
  setCommonModuleValues({
    path: '',
    visible: isGlobalModuleOpen,
  })
}

export const setSelectedTSG = (tsg: Tsg) => {
  setCommonModuleValues({
    tsg,
  })
}

export const {
  loadTsgTree,
  loadTsgInstances,
  loadApps,
  switchTsg,
  launchSingleTenantView,
  launchMultiTenantView,
  launchFawkes: launchTenant,
  launchAppDefaultRoute,
} = actions

export const launchAppInstance = (instance: Instance | undefined) => {
  const { app_id, tsg_id, url } = instance || {}
  if (!app_id || !tsg_id) {
    return
  }
  if (app_id.startsWith(APP_ID_PRISMA_ACCESS) && isAppCanBeLaunched({ ...(instance as Instance), app_id: APP_ID_PRISMA_ACCESS })) {
    launchSingleTenantView(tsg_id, PA_DEFAULT_ROUTE)
    return APP_ID_PRISMA_ACCESS
  }
  else if (isAppCanBeLaunched(instance)) {
    launchAppDefaultRoute(tsg_id, app_id)
    return app_id
  }
  else if (url) {
    window.open(url, '_blank')
  }
}

export const getSparkyCache = () => store.stateRef.current.cache as AsyncCache | undefined
